//カードテンプレートデザイン編集-パーミッション設定画面
import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Box, Grid, Radio, Container } from '@material-ui/core'
import { Button } from '@material-ui/core'

type PermissionDialogProps = {
  open: boolean
  onClose: () => void
}
const PermissionDialog:React.FC<PermissionDialogProps> = ({open, onClose}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth='md' >
      <DialogTitle>
        カードのデザイン変更の許可を設定します
      </DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <SetPermission />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='text' color='primary'>
          キャンセル
        </Button>
        <Button variant='text' color='primary' onClick={onClose}>
          保存する
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const SetPermission:React.FC = () => {
  const Allow = '許可する'
  const NotAllow = '許可しない'
  const [cardValue, setCardValue] = React.useState(Allow)
  const [templateValue, setTemplateValue] = React.useState(Allow)
  const [renameValue, setRenameValue] = React.useState(Allow)

  const cardHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCardValue((event.target as HTMLInputElement).value)
  }  
  const templateHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTemplateValue((event.target as HTMLInputElement).value)
  }  
  const renameHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRenameValue((event.target as HTMLInputElement).value)
  }
  
  return (
    <Container>
      <Box mt={3}>
        <Grid container spacing={0}>
          <Grid item xs={7}>
            <Box mt={1}>シートに貼ったカードのデザイン変更を</Box>
          </Grid>
          <Grid item xs={5}>
            <Radio
              checked={cardValue === Allow} onChange={cardHandleChange}
              value={Allow} name="card_edit" color='default'
              inputProps={{ 'aria-label': Allow }}
            />{Allow}
            <Radio 
              checked={cardValue === NotAllow} onChange={cardHandleChange}
              value={NotAllow} name="card_edit" color='default'
              inputProps={{ 'aria-label': NotAllow }}
            />{NotAllow}
          </Grid>
        </Grid>
      </Box>
      <Box mt={4}>
        <Grid container spacing={0}>
          <Grid item xs={7}>
            <Box mt={1}>カードテンプレート変更の上書き保存を</Box>
          </Grid>
          <Grid item xs={5}>
            <Radio
              checked={templateValue === Allow} onChange={templateHandleChange}
              value={Allow} name="template_edit" color='default'
              inputProps={{ 'aria-label': Allow }}
            />{Allow}
            <Radio 
              checked={templateValue === NotAllow} onChange={templateHandleChange}
              value={NotAllow} name="template_edit" color='default'
              inputProps={{ 'aria-label': NotAllow }}
            />{NotAllow}
          </Grid>
        </Grid>
      </Box>
      <Box mt={4}>
        <Grid container spacing={0}>
          <Grid item xs={7}>
            <Box mt={1}>カードテンプレートの別名による新規追加を</Box>
          </Grid>
          <Grid item xs={5}>
            <Radio
              checked={renameValue === Allow} onChange={renameHandleChange}
              value={Allow} name="rename_template" color='default'
              inputProps={{ 'aria-label': Allow }}
            />{Allow}
            <Radio 
              checked={renameValue === NotAllow} onChange={renameHandleChange}
              value={NotAllow} name="rename_template" color='default'
              inputProps={{ 'aria-label': NotAllow }}
            />{NotAllow}
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default PermissionDialog
